'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoginForm = require('./components/LoginForm.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LoginForm).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/login/lib/components/login-form/index.js
// module id = 538
// module chunks = 1